// @flow
import styled from "styled-components";
import {styles} from "../../../../config";
import {SelectionButton} from "../../../AppStyle";

export const AcceptTermsSelectionButton = SelectionButton.extend`
    background-color: ${styles.primaryColor};
`;

export const AcceptTermsLabel = styled.label`
    color: #ffffff;
    font-size: 19px;
    font-weight: 500;
    margin: 0;
`;



// WEBPACK FOOTER //
// ./src/Components/Screen/WelcomePage/AcceptTerms/AcceptTermsStyle.js